
<div class="container">
  <!--Email-->
  <div class="bl-input-container welcome-input" *ngIf="showEmail">
    <p [ngClass]="validationErrors.email.length > 0 ? 'bl-mat-label-error' : ''" class="bl-mat-label">
      {{ 'Email' | translate }} {{validationErrors.email.trim().length > 0 ? "-" + validationErrors.email : ""}}
    </p>
    <mat-form-field appearance="fill">
      <input id="email" type="email" matInput [placeholder]="'Email' | translate" [value]="userSettingsComplete.user.email" readonly>
    </mat-form-field>
  </div>

  <!--FirstName-->
  <div class="bl-input-container welcome-input">
    <p [ngClass]="validationErrors.firstName.length > 0 ? 'bl-mat-label-error' : ''" class="bl-mat-label">{{ 'First Name' | translate }} {{validationErrors.firstName.trim().length > 0 ? "-" + validationErrors.firstName : ""}}</p>
    <mat-form-field class="" appearance="fill">
      <input [maxlength]="userSettingsService.maxFirstNameChars" id="firstName" (touchend)="$event.stopPropagation()" matInput [placeholder]="'First Name' | translate" [(ngModel)]="userSettingsComplete.user.firstName">
    </mat-form-field>
  </div>

  <!--LastName-->
  <div class="bl-input-container welcome-input">
    <p  [ngClass]="validationErrors.lastName.length > 0 ? 'bl-mat-label-error' : ''"class="bl-mat-label">{{ 'Last Name' | translate }} {{validationErrors.lastName.trim().length > 0 ? "-" + validationErrors.lastName : ""}}</p>
    <mat-form-field class="" appearance="fill">
      <input [maxlength]="userSettingsService.maxLastNameChars" id="lastName" (touchend)="$event.stopPropagation()" matInput [placeholder]="'Last Name' | translate" [(ngModel)]="userSettingsComplete.user.lastName">
    </mat-form-field>
  </div>

  <!--DisplayName-->
  <div class="bl-input-container welcome-input">
    <p  [ngClass]="validationErrors.displayName.length > 0 ? 'bl-mat-label-error' : ''"class="bl-mat-label">{{ 'Display Name' | translate }} {{validationErrors.displayName.trim().length > 0 ? "-" + validationErrors.displayName : ""}}</p>
    <mat-form-field class="" appearance="fill">
      <input (keydown.enter)="finishedOnMobile.emit()" [maxlength]="userSettingsService.maxDisplayNameChars" id="displayName" (touchend)="$event.stopPropagation()" matInput [placeholder]="'Display Name' | translate" [(ngModel)]="userSettingsComplete.user.displayName">
    </mat-form-field>
  </div>

  <!--Language-->
  <div class="bl-input-container welcome-input" data-i18n-skip>
    <p class="bl-mat-label">{{ 'Language' | translate }}</p>
    <mat-form-field appearance="fill">
      <mat-select
        (touchend)="$event.stopPropagation()"
        [(ngModel)]="userSettingsComplete.user.lastLanguageId">
        <mat-option *ngFor="let language of languageService.availableLanguages" [value]="language.id">
          {{ language.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</div>

